import React, { useContext, useState, forwardRef } from 'react'
import { FormContext } from '../FormContext';
import { Col } from "react-bootstrap";
import "./customelements.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Icon from "react-bootstrap-icons";

const DateTime = ({ id, label, placeholder, value, disabled, hidden, example, mandatory, md }) => {
  const { handleChange } = useContext(FormContext)
  const ReactDateTime = () => {
    const DateCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
      <>
        <input
          value={value}
          placeholder={"Select date and time"}
          className="date-custom-input"
          onClick={onClick}
          onChange={onChange}
          ref={ref}
          disabled={disabled}
          required={mandatory}
          autoComplete="new-password"
        >
        </input>
        <Icon.Calendar2WeekFill className='calendar-icon-custom-input' />
      </>
    ));
    return (
      <DatePicker
        showIcon={true}
        selected={value}
        placeholderText={"Select date and time"}
        onChange={event => handleChange(id, event)}
        customInput={<DateCustomInput />}
        dayClassName={() => "custom-datepicker-day-class"}
        popperClassName="custom-datepicker-class"
        showTimeSelect={true}
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="time"
        dateFormat="MMMM d, yyyy h:mm aa"
      />
    );
  };
  return (
    <>
      {
        hidden ? <></> :
          <Col md={md} className="pad-trl-10">
            <div className="mb-3">
              <label htmlFor="date" className="form-label move-left">{mandatory?<span style={{color:"red", marginRight: 5}}>*</span>:""}{label}</label>
              <ReactDateTime />
              {example!==null?<div id="emailHelp" className="text-muted move-left input-example">Example: {example}</div>:<></>}
            </div>
          </Col>
      }
    </>
  )
}

export default DateTime